// Original Games (Betologics aggregator) admin section — one route per view,
// all registered in App.tsx under /original-games.
//
// Data comes from /lords/originalgames/* (staff JWT, backend
// originalgames/adminRoutes.js) except the catalogue, which is the public
// /originalgames/games. Amounts are per currency and never summed across them.

import React from "react";
import Dashboard from "./Dashboard";
import Bets from "./Bets";
import Sessions from "./Sessions";
import Games from "./Games";
import Callbacks from "./Callbacks";
import Validation from "./Validation";

export type OriginalGamesView = "dashboard" | "bets" | "sessions" | "games" | "callbacks" | "validation";

export default function OriginalGames({ view }: { view: OriginalGamesView }) {
  switch (view) {
    case "bets": return <Bets />;
    case "sessions": return <Sessions />;
    case "games": return <Games />;
    case "callbacks": return <Callbacks />;
    case "validation": return <Validation />;
    default: return <Dashboard />;
  }
}
